import React from 'react'
import { useStore, useDispatch } from 'react-redux'
import Select from 'react-select'
import OutsideClickHandler from 'react-outside-click-handler'
import { ReactComponent as CloseSvg } from '../../../assets/svg/close.svg'

import { toggleBulkEditorPane } from '../../../redux/actions/app'

const BulkEditorPaneComponent = () => {
  const dispatch = useDispatch()
  const store = useStore().getState()

  const {
    app: { masterColumns },
    vendor: { selectedLookups }
  } = store

  const handleClose = () => {
    dispatch(toggleBulkEditorPane())
  }

  return (
    <OutsideClickHandler onOutsideClick={handleClose}>
      <div className="bulk-editor-pane-component">
        <div className="pane-header">
          <div className="pane-title">
            Bulk Edits
          </div>
          <div>
            {selectedLookups && selectedLookups.length > 0 ? selectedLookups.length : 'No'} items(item) selected
            <CloseSvg className="close-button" title="Close" onClick={handleClose} />
          </div>
        </div>
        <div className="pane-body">
          {
            masterColumns.map(column => (
              <div className="field" key={column.name}>
                <div>{column.label}</div>
                <Select
                  className="master-name-options"
                  classNamePrefix="master-name-options"
                  options={selectedLookups && selectedLookups.length > 0 && selectedLookups.map(row => (
                    {
                      label: row[column.name],
                      value: row[column.name],
                    }
                  ))}
                />
              </div>
            ))
          }
        </div>
        <div className="pane-footer flex justify-space-between">
          <button type="button" className="btn btn-gray">
            Cancel
          </button>
          <button type="button" className="btn btn-black">
            Update
          </button>
        </div>
      </div>
    </OutsideClickHandler>
  )
}

export default BulkEditorPaneComponent
